import React, { useState, useContext } from 'react';
import { UserContext } from '../contexts/User';
import { FaHistory, FaComments } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import SignInModal from '../components/SigninModal';
import TierCard from '../components/TierCard';
import { TIERS } from '../config/tiers';
import '../styles/Settings.css';

const Settings = () => {
  const {
    user,
    handleSignOut,
    totalCost,
    tier,
    videoGenCount,
    imageGenCount
  } = useContext(UserContext);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const handleSignInSignUpClick = () => {
    if (user && !user.isAnonymous) {
      handleSignOut();
    } else {
      setShowModal(true);
    }
  };

  const handleUpgrade = () => {
    if (user?.isAnonymous) {
      setShowModal(true);
    }
  };

  return (
    <div className="settings-container">
      <div className="settings-header">
        <div className={`chat-nav`}>
            <FaComments className="history-icon" onClick={() => navigate('/chat')} />
        </div>
        <h2>Session Archives</h2>
      </div>
      <div className="settings-content">
        <div className="user-info">
          <p>Display Name: {user?.displayName || 'Anonymous'}</p>
          <p>Email: {user?.email || 'Anonymous'}</p>
          <button className="sign-in-button" onClick={handleSignInSignUpClick}>
            {user && !user.isAnonymous ? 'Sign Out' : 'Sign In / Sign Up'}
          </button>
        </div>
        <div className="tiers-section">
          <h3>Usage Tiers</h3>
          <div className="tier-cards">
            <TierCard
              tier={TIERS.FREE}
              isActive={tier === 'FREE'}
              currentUsage={{ cost: totalCost, videos: videoGenCount, images: imageGenCount }}
              onUpgrade={handleUpgrade}
            />
            <TierCard
              tier={TIERS.PLUS}
              isActive={tier === 'PLUS'}
              currentUsage={{ cost: totalCost, videos: videoGenCount, images: imageGenCount }}
              onUpgrade={handleUpgrade}
            />
            <TierCard
              tier={TIERS.PREMIUM}
              isActive={tier === 'PREMIUM'}
              currentUsage={{ cost: totalCost, videos: videoGenCount, images: imageGenCount }}
              disabled={true}
            />
          </div>
        </div>
      </div>
      <SignInModal isOpen={showModal} onRequestClose={() => setShowModal(false)} />
    </div>
  );
};

export default Settings;
